import { render } from "./Introduction1.vue?vue&type=template&id=2fc1fbd2&scoped=true"
import script from "./Introduction1.vue?vue&type=script&lang=js"
export * from "./Introduction1.vue?vue&type=script&lang=js"

import "./Introduction1.vue?vue&type=style&index=0&id=2fc1fbd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fc1fbd2"

export default script